import moment from 'moment';
import React from 'react';
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import SearchSelect from '../../components/SearchSelect';
import { responseError } from '../../helpers/responseHandler';
import { useGetSelectDriversQuery } from '../../redux/services/DriverService';
import { useAddJobMutation, useEditJobMutation } from '../../redux/services/JobService';
import { sweetAlert } from '../../utils';

const JobsAddModal = ({ show, handleClose, isEdit }) => {
    const navigate = useNavigate()
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [addRequest, { isLoading: addLoading }] = useAddJobMutation()
    const [editRequest, { isLoading: editLoading }] = useEditJobMutation()

    const { data: data2 } = useGetSelectDriversQuery()
    const drivers = data2?.response?.data




    const onSubmit = async (data) => {
        data['driver_id'] = data?.driver_id?.value > 0 ? data?.driver_id?.value : ''
        // data['job_time'] = data?.job_time && moment(data?.job_time, 'HH:mm').format('HH:mm')
        if (isEdit) {
            const newForm = { ...data }
            await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = { ...data }
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }

    return (
        <>
            <Modal show={show} onHide={() => handleClose()}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Add Driver Job</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='driver-status'>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Driver Name:</Form.Label>
                            {/* <Controller
                                name="driver_id"
                                control={control}
                                defaultValue={isEdit?.driver_id || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Select
                                        {...field}
                                        type="text" placeholder="Enter Driver Name"
                                        isInvalid={errors.driver_id}
                                    >
                                        <option value="">Please Select</option>
                                        {drivers?.map((driver) => (
                                            <option value={driver?.id} key={driver?.id}>{driver?.full_name}</option>
                                        ))}
                                    </Form.Select>
                                )}
                            /> */}
                            <Controller
                                name="driver_id"
                                control={control}
                                defaultValue={
                                    (isEdit?.driver_id && isEdit?.driver) ?
                                        (
                                            { label: isEdit?.driver?.full_name, value: isEdit?.driver?.id }
                                        ) :
                                        null
                                }
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <>
                                        <SearchSelect
                                            options={drivers?.map((item) => ({ value: item?.id, label: item?.full_name }))}
                                            field={field}
                                            placeholder={"Select Approved Driver"}
                                        />
                                        {errors.driver_id && <div className="invalid-feedback d-block">This field is required</div>}
                                    </>

                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Job Date:</Form.Label>
                            <Controller
                                name="job_date"
                                control={control}
                                defaultValue={isEdit?.job_date || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="date"
                                        isInvalid={errors.job_date}
                                    />
                                )}
                            />
                        </Form.Group>
                        {/* <Form.Group className="mb-3">
                            <Form.Label>Job Time:</Form.Label>
                            <Controller
                                name="job_time"
                                control={control}
                                defaultValue={isEdit?.job_time || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="time"
                                        isInvalid={errors.job_time}
                                    />
                                )}
                            />
                        </Form.Group> */}

                        <Form.Group className="mb-3">
                            <Form.Label>Original Location:</Form.Label>
                            <Controller
                                name="origin_location"
                                control={control}
                                defaultValue={isEdit?.origin_location || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        as={'textarea'}
                                        rows={2}
                                        {...field}
                                        type="time"
                                        isInvalid={errors.origin_location}
                                    />
                                )}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Delivery Location:</Form.Label>
                            <Controller
                                name="delivery_location"
                                control={control}
                                defaultValue={isEdit?.delivery_location || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        as={'textarea'}
                                        rows={2}
                                        {...field}
                                        type="time"
                                        isInvalid={errors.delivery_location}
                                    />
                                )}
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Broker Detail:</Form.Label>
                            <Controller
                                name="broker_details"
                                control={control}
                                defaultValue={isEdit?.broker_details || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter Broker Detail"
                                        isInvalid={errors.broker_details}
                                    />
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>C-Number:</Form.Label>
                            <Controller
                                name="c_number"
                                control={control}
                                defaultValue={isEdit?.c_number || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter C-Number"
                                        isInvalid={errors.c_number}
                                    />
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Job Detail:</Form.Label>
                            <Controller
                                name="job_details"
                                control={control}
                                defaultValue={isEdit?.job_details || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="text" placeholder="Enter Job Detail"
                                        isInvalid={errors.job_details}
                                    />
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Miles:</Form.Label>
                            <Controller
                                name="miles"
                                control={control}
                                defaultValue={isEdit?.miles || ''}
                                rules={{
                                    required: true
                                }}
                                render={({ field }) => (
                                    <Form.Control
                                        {...field}
                                        type="number" placeholder="Enter Miles"
                                        isInvalid={errors.miles}
                                    />
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Hourly Job Payment Rate:</Form.Label>
                            <div className="input-group align-items-center">
                                <span className="input-group-addon">$</span>
                                <Controller
                                    name="hourly_rate"
                                    control={control}
                                    defaultValue={isEdit?.hourly_rate || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="number" placeholder="Enter Payment Rate"
                                            isInvalid={errors.hourly_rate}
                                        />
                                    )}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Job Amount:</Form.Label>
                            <div className="input-group align-items-center">
                                <span className="input-group-addon">$</span>
                                <Controller
                                    name="job_amount"
                                    control={control}
                                    defaultValue={isEdit?.job_amount || ''}
                                    rules={{
                                        required: true
                                    }}
                                    render={({ field }) => (
                                        <Form.Control
                                            {...field}
                                            type="number" placeholder="Enter Job Amount"
                                            isInvalid={errors.job_amount}
                                        />
                                    )}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3 d-none">
                            <Form.Label>Create Date & Time:</Form.Label>
                            <Form.Control type="datetime-local" />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="driver-status"
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default JobsAddModal;